import { DynamicImageLoader } from './DynamicImageLoader';
import type { ImageLoaderProps } from 'next/dist/shared/lib/image-config';
import magnoliaImageLoader from './magnoliaImageLoader';
import nextJsLoader from './nextJsLoader';

type ImageLoader = (p: ImageLoaderProps, disableNextJsLoader?: boolean) => string;

const imageLoader: ImageLoader = (props, enableNextJsLoader = true) => {
  let href: string = props.src;
  const imageLoaders: Array<DynamicImageLoader> = [];

  if (process.env.NEXT_PUBLIC_REGISTER_MAGNOLIA_LOADER === 'true') {
    imageLoaders.push(magnoliaImageLoader);
  }

  if (enableNextJsLoader) {
    imageLoaders.push(nextJsLoader);
  }

  for (const imageLoader of imageLoaders) {
    const loaderHref = imageLoader(props);
    if (loaderHref !== undefined) {
      href = loaderHref;
      break;
    }
  }

  return href;
};

export default imageLoader;
